import React, { useState, useCallback, lazy, Suspense, useRef } from 'react';

// Redux
import { useDispatch } from 'react-redux';

// date-fns

// Material
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

// ReactCSV
import { CSVLink } from 'react-csv';

// Helpers
import { formatDateAndTime } from 'helpers/date';

// Actions
import { setOpen, setClose } from 'store/ducks/dialogs/actions';
import * as ReportActions from 'store/ducks/reports/actions';

// Constants
import { REPORTS_TYPES } from 'constants/report';
import ITEMS from 'constants/itemsByFilter';
import TITLES_OPTIONS from 'constants/infoModulesTitle';

// Components
import { MainContent, SearchComponent, ReportTitle } from 'components';
import { TablePlaceholder } from 'components/TablePlaceholder';
import { TabPanel } from 'components/TabPanel';
import { Submissions, History } from '../../../../components';

// Styles
import useStyles from './LineDemandReportDatails.styles';

// Lazy Components
const TableLineDemandReport = lazy(() =>
  import('./components/TableLineDemandReport/TableLineDemandReport'),
);
const Filter = lazy(() => import('components/Filter'));

interface EmtuReportDatailsProps {
  setSubmissionData: (param: any) => void;
  setIsAddSubmissiion: (param: any) => void;
  setIsEditSubmissiion: (param: any) => void;
}

const LineDemandReportDatails: React.FC<EmtuReportDatailsProps> = ({
  setSubmissionData,
  setIsAddSubmissiion,
  setIsEditSubmissiion,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const csvRef = useRef(null);

  const [reportIsVisible, setReportIsVisible] = useState(false);
  const [tableCSV, setTableCSV] = useState('');
  const [generalNavGuide, setGeneralNavGuide] = useState(0);
  const [periodString, setPeriodString] = useState('');

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setGeneralNavGuide(newValue);
  };

  const handleLoadData = useCallback(() => {
    setReportIsVisible(true);
    dispatch(
      ReportActions.lineDemandReportRequest({
        startDate: new Date().setHours(0, 0, 0),
        endDate: new Date().setHours(23, 59, 59),
      }),
    );

    const tempPeriodString = `Dia: ${new Date().toLocaleDateString('pt-BR', {
      dateStyle: 'short',
    })}`;

    setPeriodString(tempPeriodString);
    // setInitialFilters();
  }, [dispatch]);

  const handleApply = useCallback(
    (data: any) => {
      dispatch(setClose({}));
      setReportIsVisible(true);

      const {
        startedAt,
        startDate,
        endDate,
        selectedLines,
        selectedSeccionedLine,
      } = data;

      const isPeriod = startDate?.getTime() < endDate?.getTime();
      let startDateValue;
      let endDateValue;
      if (isPeriod) {
        startDateValue = new Date(startDate).getTime();
        endDateValue = new Date(endDate).getTime();
      } else if (startedAt) {
        startDateValue = new Date(startedAt).setHours(0, 0, 0);
        endDateValue = new Date(startedAt).setHours(23, 59, 59);
      }
      dispatch(
        ReportActions.lineDemandReportRequest({
          startDate: startDateValue,
          endDate: endDateValue,
          lineId:
            selectedLines.length > 0
              ? selectedLines.map((e: any) => e.id).join()
              : undefined,
          seccioned: Boolean(selectedSeccionedLine),
        }),
      );

      const tempPeriodString = `De: ${
        isPeriod
          ? formatDateAndTime(new Date(startDate))
          : formatDateAndTime(new Date(startedAt))
      } até: ${
        isPeriod
          ? formatDateAndTime(new Date(endDate))
          : formatDateAndTime(new Date(startedAt))
      }`;

      let updatedPeriodString = tempPeriodString;

      if (selectedLines?.length > 0) {
        const tempLinesString = `Linhas: ${selectedLines
          .map((e: any) => e.name)
          .join(', ')}`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      setPeriodString(updatedPeriodString);
    },
    [dispatch],
  );

  return (
    <div className={classes.root}>
      <MainContent className={classes.paperRoot}>
        <Grid
          container
          justifyContent='space-between'
          className={classes.gridContainer}>
          <Grid container className={classes.paperTitle}>
            <ReportTitle
              titleVariant='h4'
              title='Relatórios de Operação • Demanda por Linha'
              tooltipTitle={
                TITLES_OPTIONS.REPORTS.OPERATION.DEMAND_PER_LINE.VALUE
              }
            />

            <Grid item>
              <CSVLink
                filename='Relatório_de demanda_por_linha.csv'
                data={tableCSV}
                ref={csvRef}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container direction='column'>
          <Grid item className={classes.scopeFilter}>
            <Box
              display='flex'
              alignItems='center'
              width='100%'
              marginTop='16px'>
              <SearchComponent
                disabledInput={!reportIsVisible}
                modalFilter={() => {
                  dispatch(
                    setOpen({
                      open: true,
                      content: (
                        <Suspense fallback={<p>Carregando...</p>}>
                          <Filter
                            fields={ITEMS.lineDemand}
                            handleApply={handleApply}
                          />
                        </Suspense>
                      ),
                      maxWidth: 'xl',
                    }),
                  );
                }}
              />
              {/* <Grid container justifyContent='flex-end'>
                <Button
                  className={classes.addButton}
                  onClick={() => setIsAddSubmissiion(true)}>
                  <Typography style={{ marginRight: 8, fontSize: 20 }}>
                    +
                  </Typography>{' '}
                  <Typography style={{ fontSize: 12 }}>
                    Programar Novo
                  </Typography>
                </Button>
              </Grid> */}
            </Box>
          </Grid>
        </Grid>
        <Tabs
          indicatorColor='primary'
          onChange={handleChange}
          style={{
            background: '#ffffff',
            margin: '10px 0px 32px 16px',
          }}
          textColor='primary'
          value={generalNavGuide}>
          <Tab label='Relatório' />
          <Tab label='Envios' />
          <Tab label='Histórico' />
        </Tabs>

        <TabPanel index={0} value={generalNavGuide}>
          {!reportIsVisible && <TablePlaceholder onClick={handleLoadData} />}
          {reportIsVisible && (
            <Suspense fallback={<p>Loading...</p>}>
              <TableLineDemandReport
                setTableCSV={setTableCSV}
                periodString={periodString}
                csvRef={csvRef}
              />
            </Suspense>
          )}
        </TabPanel>
        <TabPanel index={1} value={generalNavGuide}>
          <Submissions
            setSubmissionData={setSubmissionData}
            setIsEditSubmissiion={setIsEditSubmissiion}
            reportType={REPORTS_TYPES.LINE_VALUE}
          />
        </TabPanel>
        <TabPanel index={2} value={generalNavGuide}>
          <History reportType={REPORTS_TYPES.LINE_VALUE} />
        </TabPanel>
      </MainContent>
    </div>
  );
};

export { LineDemandReportDatails };
export default LineDemandReportDatails;
